









import { defineComponent, computed } from '@vue/composition-api';
import { useGlobals }                from '@/hooks/use-globals';
import { Computed }                  from '@/types';
import { Calendar }                  from '@/views/seasons/seasons.types';
import CSeasonsMonth                 from '@/views/seasons/components/seasons-calendar/seasons-month/seasons-month.component.vue';

export default defineComponent({
  name: 'cSeasonsCalendar',
  components: { CSeasonsMonth },
  setup() {
    const { store } = useGlobals();
    const calendar: Computed<Calendar> = computed(() => store.state.views.vSeasons.calendar);

    return {
      calendar,
    };
  },
});
